export function applyMaskToValue (value: string, mask = 'DDDD/DD/DD')  {
  // console.log(`applyMaskToValue: "${value}" - "${mask}"`)

  const matchers = {
    "D": /\d/,
  };

  let result = '';
  let k = 0;
  let unmatched = ''
  for (let i = 0; i < mask.length; i++) {
    const fkey = mask[i];
    if (!(fkey in matchers)) {
      unmatched += fkey;
      continue;
    }
    const matcher = new RegExp(matchers[fkey]);
    while (k < value.length) {
      if (value[k].match(matcher)) {
        result += unmatched
        unmatched = ''

        result += value[k];
        k++;
        break;
      }
      k++;
    }

    if (k >= value.length) {
      break;
    }
  }
  return result;
}
